import type { FC, PropsWithChildren } from "react";

import type { GlobalRoute } from "../../core/router/types/routerTypes";
import { LinkStyle } from "./LinkStyle";

type LinkProps = Readonly<{ route: GlobalRoute; className?: string; to: string; showNotAllowed?: boolean }> & PropsWithChildren;

/**
 * Do not render link if me has no required roles to do this
 *
 * @param route - whole route object
 * @param to - path to where redirect, route.fillPathParams(pathParams) could be used but this is type stronger
 * @param children
 * @param className
 */
export const ActionLink: FC<LinkProps> = ({ to, children, className }) => {
    return (
        <LinkStyle to={to} className={className}>
            {children}
        </LinkStyle>
    );
};
